import { render, staticRenderFns } from "./BulkImport.vue?vue&type=template&id=501e2e55&scoped=true&"
import script from "./BulkImport.vue?vue&type=script&lang=js&"
export * from "./BulkImport.vue?vue&type=script&lang=js&"
import style0 from "./BulkImport.vue?vue&type=style&index=0&id=501e2e55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501e2e55",
  null
  
)

export default component.exports